import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ResourceComponent } from './resource/resource.component';
import { RisksComponent } from './risks/risks.component';
import { ProjectComponent } from './project/project.component';
import { StakeholdersComponent } from './stakeholders/stakeholders.component';
import { IMilestone, IProject, IRisk, IStakeholder, ITeamMember } from '../../../interfaces/models/project.model';
import { TeamMemberComponent } from './team-member/team-member.component';
import { ProjectSubmissionComponent } from './project-submission/project-submission.component';
import { MilestoneComponent } from './milestone/milestone.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subscription, forkJoin, of, switchMap } from 'rxjs';
import { StrategyService } from '../../../services/strategy.service';
import { Strategy } from '../../../interfaces/models/strategy.model';
import { ProjectService } from '../../../services/project.service';
import { PeriodicEvaluationComponent } from './project-submission-result/project-submission-result.component';
import { ProjectAssessmentComponent } from './project-review/project-review.component';
import { ChatComponent } from './chat/chat.component';
import { PlanComponent } from './plan/plan.component';
import { authUser, RolesEnum } from '../../../interfaces/auth/auth.model';
import { AuthService } from '../../../services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../../services/direction.service';
import { SocketService } from '../../../services/socket.service';
import { SignalRService } from '../../../services/signal-r.service';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-create-project',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    InputTextareaModule,
    ButtonModule,
    AccordionModule,
    PanelModule,
    TableModule,
    StepperModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    IconFieldModule,
    InputIconModule,
    RadioButtonModule,
    ResourceComponent,
    RisksComponent,
    ProjectComponent,
    StakeholdersComponent,
    TeamMemberComponent,
    ProjectSubmissionComponent,
    MilestoneComponent,
    PeriodicEvaluationComponent,
    ProjectAssessmentComponent,
    ChatComponent,
    PlanComponent,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './create-project.component.html',
  styleUrl: './create-project.component.scss'
})
export class CreateProjectComponent implements OnInit, OnDestroy {
  @ViewChild(ProjectComponent) appProject!: ProjectComponent;
  @ViewChild(ResourceComponent) resourceCom!: ResourceComponent;
  @ViewChild(StakeholdersComponent) appStakeholder!: StakeholdersComponent;

  private readonly subscriptions = new Subscription();
  active = 0;
  strategyId = 0;
  projectId = 0
  project = {} as IProject;
  strategy = {} as Strategy;
  milestones = [] as IMilestone[];
  team_members = [] as ITeamMember[];

  risks = [] as IRisk[];
  isCompleteStatus!: boolean;
  is_submitted!: boolean;
  resource!: any;
  // stakeholder!: IStakeholder;
  is_allowed_to_submit!: boolean;
  ProjectsRelations!: any
  strategicRelations!: any;
  submissionId = 0;
  user = {} as authUser;

  get canSeeStrategyReviewTabs(): boolean {
    const role = this.user?.role as string | number;
    return role === RolesEnum.strategy_admin
      || role === RolesEnum.senior_admin
      || role === 1
      || role === 2;
  }




  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private strategyService: StrategyService,
    private authService: AuthService,
    private directionService: DirectionService,
    private socket: SocketService,
    private signalRervice: SignalRService,
    private http: HttpClient
  ) {


  }

  dir!: 'rtl' | 'ltr';



  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.signalRervice.listenToProjectMessages().subscribe((message: any) => {
      console.log("listenToProjectMessages", message);
      this.signalRervice.forwardMessageFn(message);
    })


    this.authService.authBufferSub$.subscribe((user) => {
      if (user) {
        this.user = user;
      }
    })

    const strategyId = this.route.snapshot.paramMap.get('strategyId') || '0'
    const projectId = this.route.snapshot.paramMap.get('projectId') || '0'


    if (!projectId && !strategyId) {
      return;
    }

    if (+projectId == 0) {
      this.strategyId = +strategyId;
      this.projectId = 0;
      
      forkJoin({
        strategy: this.strategyService.getStrategyById(strategyId),
        strategicRelations: this.projectService.getStrategicRelations(+strategyId),
        departments: this.http.get(environment.domain + 'hierarchy/departments'),
        sections: this.http.get(environment.domain + 'hierarchy/sections')
      }).subscribe((response: any) => {
        this.strategy = { ...response.strategy['data']['strategy'] }
        this.strategicRelations = response.strategicRelations;
        
        // Initialize ProjectsRelations with departments and sections
        this.ProjectsRelations = {
          inChargeUnits: [],
          inChargeExecutives: [],
          supportingUnits: [],
          employees: [],
          departments: response.departments.data?.departments || response.departments.departments || [],
          sections: response.sections.data?.sections || response.sections.sections || [],
          levels: [],
          levelValues: {},
          riskTypes: [],
          isPositiveNames: {},
          unitEmployeesMap: {},
          inChargeUnitName: null
        };
        
        this.authService.authBufferSub$.subscribe((user) => {
          if (user) {
            this.user = user;
          }
        })
      })
    } else {

      this.subscriptions.add(this.route.params.pipe(switchMap((param) => {
        this.strategyId = param["strategyId"];
        this.projectId = param["projectId"];
        return forkJoin({
          'project': this.projectService.getProject(this.strategyId, this.projectId),
          'strategy': this.strategyService.getStrategyById(this.strategyId.toString()),
          'ProjectsRelations': this.projectService.ListProjectsRelations(this.strategyId, this.projectId)
        })
      })).subscribe((response: any) => {
        this.project = { ...response['project'] }
        this.project.assessments = this.project?.assessments || [] as any;
        this.project.govLinks = this.project?.govLinks || [] as any;
        this.project.strategicLinks = this.project?.strategicLinks || [] as any;
        
        // Merge team members (employees) with team units (departments/sections)
        const teamMembers = response['project'].team_members || [];
        const teamUnits = response['project'].team_units || [];
        this.team_members = [...teamMembers, ...teamUnits];
        
        this.resource = response['project'].resource as any;
        this.ensureProjectResource();
        this.risks = response.project.risks as IRisk[];
        this.isCompleteStatus = response.project.isCompleteStatus;
        this.is_submitted = response.project.is_submitted;
        this.is_allowed_to_submit = response.project.is_allowed_to_submit;
        this.milestones = response.project.milestones as IMilestone[];
        this.ProjectsRelations = { ...response['ProjectsRelations']['data'] }
        this.syncProjectStakeholderFromRelations(this.ProjectsRelations?.stakeholder);
        this.ensureProjectStakeholder();
        this.strategy = { ...response['strategy']['data']['strategy'] }
        const projAssessments = response?.project?.projectAssessments || [];
        this.submissionId = projAssessments.find((x: any) => x?.is_main)?.id || 0;

        this.projectService.getStrategicRelations(+this.strategy.id).subscribe((response: any) => {
          this.strategicRelations = response;
        });



        this.authService.authBufferSub$.subscribe((user) => {
          if (user) {
            this.user = user;
          }
        })

      }))

    }


  }
  submitProjectForm() {
    this.appProject.onProjectSubmit();
  }
  submitResourceForm() {
    this.resourceCom.submitResource()
  }
  ProjectSubmitSuccess(ids: { projectId: number, strategyId: number }) {

    this.subscriptions.add(of({ projectId: ids.projectId, strategyId: ids.strategyId }).pipe(switchMap((param) => {
      this.projectId = param["projectId"];
      this.strategyId = param["strategyId"];
      
      // Save team units that were added before project creation
      const unitsToSave = this.team_members.filter((tm: any) => tm.unit_type && tm.id > 1000000000);
      if (unitsToSave.length > 0) {
        // Save each unit
        unitsToSave.forEach((unit: any) => {
          const createData = {
            unit_type: unit.unit_type,
            unit_id: unit.unit_id,
            activity: unit.activity
          };
          this.projectService.createTeamUnit(this.strategyId, this.projectId, createData).subscribe({
            next: (response: any) => {
              console.log('Team unit saved successfully');
            },
            error: (err) => {
              console.error('Error saving team unit:', err);
            }
          });
        });
        
        // Clear sessionStorage after saving to backend
        const storageKey = `temp_project_team_members_${this.strategyId}`;
        sessionStorage.removeItem(storageKey);
      }
      
      return forkJoin({
        'project': this.projectService.getProject(this.strategyId, this.projectId),
        'strategy': this.strategyService.getStrategyById(this.strategyId.toString()),
        'ProjectsRelations': this.projectService.ListProjectsRelations(this.strategyId, this.projectId)
      })
    })).subscribe((response: any) => {

      this.project = { ...response['project'] }
      this.ProjectsRelations = { ...response['ProjectsRelations']['data'] }
      this.syncProjectStakeholderFromRelations(this.ProjectsRelations?.stakeholder);
      this.ensureProjectStakeholder();
      // this.stakeholder = this.project.stakeholder as IStakeholder;
      
      // Merge team members (employees) with team units (departments/sections)
      const teamMembers = response['project'].team_members || [];
      const teamUnits = response['project'].team_units || [];
      this.team_members = [...teamMembers, ...teamUnits];
      
      this.resource = response['project'].resource as any;
      this.ensureProjectResource();
      this.risks = response.project.risks as IRisk[];
      this.isCompleteStatus = response.project.isCompleteStatus;

      this.is_submitted = response.project.is_submitted;
      this.is_allowed_to_submit = response.project.is_allowed_to_submit;
      // this.completionStatus = response.project.completionStatus as any[];
      this.milestones = response.project.milestones as IMilestone[];
      this.ProjectsRelations = { ...response['ProjectsRelations']['data'] }
      this.strategy = { ...response['strategy']['data']['strategy'] }
      console.log("active 1");

      this.active = 1;



    }))
  }
  changeIsSubmitted(event: {created: boolean, submissionId: number}) {
    this.project.is_submitted = event.created;
    this.submissionId = event.submissionId;
  }

  submitResourceSuccess() {
    console.log("success");
    this.active = 4;
  }
  submitStakeholdersForm() {
    this.appStakeholder.onSubmit();
  }
  StakeholderSuccess(stackholder: IStakeholder) {
    console.log('stackholder $$', stackholder);
    this.project.stakeholder = stackholder;
    this.active = 2;
  }
  goBack() {
    window.history.back();
  }

  private ensureProjectStakeholder(): void {
    if ((this.project?.stakeholder?.id ?? 0) > 0) {
      return;
    }

    this.project.stakeholder = {
      id: 0,
      project_id: +this.projectId,
      entity_in_charge_id: 0,
      entity_in_charge_type: '',
      executive_in_charge_id: 0,
      supporting_units: [],
      support_in_charge: '',
      partners: '.',
      partners_link_description: '.',
      supporters: '.',
      supporters_link_description: '.',
      created_at: new Date(),
      updated_at: new Date(),
      deleted_at: null as any,
      is_deleted: false,
    };
  }

  private syncProjectStakeholderFromRelations(stakeholder: IStakeholder | null | undefined): void {
    if (!stakeholder?.id) {
      return;
    }

    this.project.stakeholder = stakeholder;
  }

  private ensureProjectResource(): void {
    if ((this.resource?.id ?? 0) > 0) {
      return;
    }

    const projectResource = this.project?.resource ?? this.project?.projectResource;
    if ((projectResource?.id ?? 0) > 0) {
      this.resource = projectResource;
      return;
    }

    this.resource = {
      id: 0,
      project_id: +this.projectId,
      estimated_budget: null,
      sponsor_engagement: null,
      required_internal_resources: '',
      required_external_resources: '',
      rationalization_method: '',
      budget_items: [],
      is_within_budget_limit: true,
    };
  }

  onTeamMembersChanged(teamMembers: ITeamMember[]) {
    console.log('Team members changed:', teamMembers);
    this.team_members = teamMembers;
  }

  onTeamLeaderChanged(teamLeader: any) {
    console.log('Team leader changed:', teamLeader);
    // Update can be handled here if needed
  }

}
